(function () {
/* ADD 2025/10/21 zhang START*/
  /* 大洲切换 */
  document.addEventListener('DOMContentLoaded', function() {
    const continentTabs = document.querySelectorAll('.continent-tab');
    const countryGroups = document.querySelectorAll('.country-group');

    // 2. 遍历按钮绑定事件
    continentTabs.forEach(tab => {
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // 3. 获取点击大洲名称
        const targetContinent = this.dataset.continent;

        if (!targetContinent) return;

        // 4. 切换按钮激活状态
        continentTabs.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');

        // 5. 切换国家列表（通过data-continent精准匹配）
        countryGroups.forEach(group => {
          const groupContinent = group.dataset.continent;
          if (groupContinent === targetContinent) {
            group.classList.remove('is-hidden');
            group.classList.add('is-visible');
          } else {
            group.classList.remove('is-visible');
            group.classList.add('is-hidden');
          }
        });
      });
    });
  });
/* ADD 2025/10/21 zhang END*/

  const footer = () => {
    const footerDetails = document.querySelectorAll('.footer .accordion details');
    footerDetails.forEach((targetDetail) => {
      targetDetail.addEventListener('click', () => {
        footerDetails.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute('open');
          }
        });
      });
    });
  };

  document.addEventListener('shopify:section:load', footer);
  footer();
})();